import React from "react";
import ReactDOM from "react-dom/client";
import "@fontsource-variable/mona-sans/standard.css";
import "@fontsource/instrument-serif/latin-400-italic.css";
import "@fontsource-variable/geist-mono/wght.css";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
